// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22.4127 10.9169L11.9994 1.66064L4.33865 8.50064L1.58984 10.9058L2.90685 12.411L4.00092 11.4537V21.9999H8.5V16H15.5V21.9999H20.0009V11.449L21.084 12.4117L22.4127 10.9169ZM13 9H15V11H13V13H11V11H9V9H11V7H13V9Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10.5 22V18H13.5V22H10.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-hospital-1-filled')
export default class Hospital1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'hospital-1-filled',
    }
  }
}
